import { InvestorTransferorReadInformationDataList } from "gen/model/investorTransferorReadInformationDataList";
import {
  formatMoney,
  moneyToString,
  sumMoneyStrings,
  zeroMoney,
} from "shared/utils/MoneyUtils";

export const getTotalTransferAmountForTransferors = (
  transferors: InvestorTransferorReadInformationDataList | undefined,
): string =>
  transferors
    ? sumMoneyStrings(
        transferors.map((transferor) => transferor.transfer_amount),
      )
    : formatMoney(moneyToString(zeroMoney()));

export const getTotalCommitmentAmountForTransferors = (
  transferors: InvestorTransferorReadInformationDataList,
): string =>
  sumMoneyStrings(
    transferors.map((transferor) => transferor.commitment_amount),
  );
